import React from 'react';
import { Container } from './Container';
import { Button } from './Button';
import { finalImage } from '../data/content';
export function FinalCta() {
  const scrollToBuy = () => {
    document.getElementById('buy')?.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  };
  return <section aria-labelledby="final-heading" className="paper-grain relative bg-shell py-16 sm:py-24" data-id="element-61" data-mp="15dlu8ylzewt5">
      <Container className="relative" data-id="element-62" data-mp="1jclja7depdpu">
        <div className="mx-auto max-w-[760px] text-center" data-id="element-63" data-mp="1jbk71zknml6j">
          <h2 id="final-heading" className="font-display text-[34px] font-extrabold leading-[1.08] tracking-[-0.028em] text-ink sm:text-[48px]" data-id="element-64" data-mp="1eek2xu7d7si2">
            Turn Your Printer Into
            <span className="pop-blue block" data-id="element-65" data-mp="1o4wjlbc271ix">an Endless Source of Things to Build.</span>
          </h2>
          <p className="mx-auto mt-6 max-w-[460px] text-[17px] font-bold leading-[1.45] text-muted sm:text-[20px]" data-id="element-66" data-mp="224o2nqhfn83s">
            1,200+ projects. One download. A new creation whenever boredom hits.
          </p>
        </div>

        <figure className="mt-11 rounded-[24px] border border-hairline bg-white p-2 shadow-lift sm:mt-14 sm:p-3" data-id="element-67" data-mp="n7fe3ktkuubg">
          <img src={finalImage.src} alt={finalImage.alt} loading="lazy" className="aspect-[4/3] w-full rounded-[16px] object-cover sm:aspect-[16/9]" data-id="element-68" data-mp="s6s248w6q7fm" />
        </figure>

        <div className="mx-auto mt-11 max-w-[520px] text-center" data-id="element-69" data-mp="164qbezvnfdo9">
          <Button variant="go" onClick={scrollToBuy} data-id="element-70" data-mp="162dyj14qzti2">
            Get the 3D Paper Craft Mega Kit
          </Button>
          <p className="mt-4 text-[15px] text-muted" data-id="element-71" data-mp="1fu9wmc6u3jma">Instant digital access • One-time payment</p>
          <p className="mt-2 font-display text-[11px] font-bold uppercase tracking-[0.2em] text-ink" data-id="element-72" data-mp="1fwmekpcldtzc">
            100% digital — nothing is shipped.
          </p>
        </div>
      </Container>
    </section>;
}